/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespCategoryTiles_itemSearch = {
    readonly displayUriRef: string | null;
    readonly categoryTiles: ReadonlyArray<{
        readonly displayName: string | null;
        readonly rank: number | null;
        readonly url: string | null;
        readonly image: string | null;
        readonly masterImage: string | null;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedCategoryTilesTracking_itemSearch">;
    readonly " $refType": "SbRespCategoryTiles_itemSearch";
};
export type SbRespCategoryTiles_itemSearch$data = SbRespCategoryTiles_itemSearch;
export type SbRespCategoryTiles_itemSearch$key = {
    readonly " $data"?: SbRespCategoryTiles_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespCategoryTiles_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespCategoryTiles_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayUriRef",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SearchBrowseCategoryTiles",
      "kind": "LinkedField",
      "name": "categoryTiles",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rank",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "image",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "masterImage",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedCategoryTilesTracking_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = '08906dc1ec1f9d5b67ca55ae05c2a6f3';
export default node;
